class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.results = this.querySelector('#predictive-search');
    this.timer = null;

    this.input.addEventListener('input', this.onChange.bind(this));
  }

  onChange() {
    clearTimeout(this.timer);

    const query = this.input.value.trim();

    if (!query.length) {
      this.results.innerHTML = '';
      return;
    }

    this.timer = setTimeout(() => {
      fetch(`/search/suggest?q=${query}&resources[type]=product,collection,page,article,query&section_id=predictive-search`)
        .then(res => res.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const results = doc.querySelector('#predictive-search-results');

          if (results) {
            this.results.innerHTML = results.outerHTML;
          }
        });
    }, 300);
  }
}

customElements.define('predictive-search', PredictiveSearch);